import TodoAdd from '@/components/todo-create';
import ListePatient from '@/components/dashboard/liste-patients' 

import CreanceVuePatients from '@/components/caisse/factures/creance-patients'
import BonsAttente from '@/components/dashboard/bons-attente'
import PrintBonMedical from '@/components/caisse/manage-bons/print-bon-medical'
import FactureEnCours from '@/components/dashboard/facture-en-cours'
import $ from 'jquery';
import { openSelectOptions, selectOption, cr_state } from '@/select-box.js';
import { open_menu_state, openMenu, closeMenu } from '@/function/function.js';
import api from "@/api/clinique/_consultations"
import store_consultation from "@/store/mods/clinique/consultations"

export default {
    name: 'dashboard',
    components: {
        TodoAdd, ListePatient,
        CreanceVuePatients,
        BonsAttente, PrintBonMedical, FactureEnCours
    },
    props: [],
    data() {
        return {
            // Role utilisateur 
            user_role: 0,
            compte_id: 0,
            user_id: 0,
            statut_ouverture_caisse: 0,

            curr_state: cr_state,
            idUser: 1,
            init_bon: null,
            active: false,
            init_anl: null,
            types_value: null,
            moments_error: null,
            types_error: null,
            total_recettes: 0,
            total_depenses: 0,
            total_versements_faits: 0,
            total_versements_recus: 0,

            // ------- CONSULTATION  ---------
            vm_state: open_menu_state,

            monthConsultationsLoading: false,
            jr_selected: 'Aujourd\'hui',
            mm_selected: 'Mars',
            consult_month_selected: {
                french: null
            },
            date: new Date(),
            monthsLatest: new Array(),
            // ------------------------------
            solde_courant: 0,
            open_loading: false,
            loader: true,

            cash_register_is_closed: false,
            status_is_loading: true,

            rdv_fields: [
                'date', { key: 'medecin', label: 'Médecin' }, { key: 'patient', label: 'Patient' },
                { key: 'date_rdv', label: 'Date du rendez-vous' }
            ],
            rdv_filter: "",

            stat_consultation_en_attente: 0,
            stat_consultation_du_jour: 0,
            
            liste_rdv: [],
            rdv_empty: false,
            rdv_loading: true,
            
            is_creance_patient: false,
            filter_data: {},
            config_to_show: 'bon-attente',
            bon_is_printable: false,
            is_bon_consultation: false,
            info_bon: {}
        }
    },

    watch: {
        
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        userCompte() {
            return this.$store.getters["compteActiveUser"];
        },

        quick_actions() {
            return this.$store.getters["quickActionsDropdown"];
        },

        /**
         * Liste des patients en attente de consultation
         * @returns 
         */
        consultationsEnAttente() {
            return this.$store.getters['consultationsEnAttente'];
        },


        /**
         * Compte le nombre de consultation du mois choisi
         * @returns 
         */
        currentMonth() {
            return this.latestMonthsOfCurrentYear[this.date.getMonth()];
        },

        monthConsultations() {
            return this.$store.getters['currentMonthConsultationsCount'];
        },

        months() {
            return this.monthsOfYear();
        },

        latestMonthsOfCurrentYear() {
            let index;

            for (index = 0; index < this.date.getMonth() + 1; index++) {
                this.monthsLatest[index] = this.months[index];

            }
            return this.monthsLatest;
        },

        solde_disponible() {
            return this.$store.getters["solde_disponible"];
        },

        info_clinique_active() {
            return this.$store.getters["info_clinique_active"]
        },

        // ----------NEW ------------
        etat_ouverture_caisse() {
            return this.$store.getters['etat_ouverture_caisse'];
        },
    },
    mounted() {
        this.$store.commit("SET_PAYING_BILL_STATE", '');
        this.$store.commit("SET_BILL_SELECTED_OPERATIONS", []);
        this.$store.commit("SET_PAYING_BILL_STATE", '');
        this.$store.commit("SET_IS_PAID", false);

        this.$store.commit("SET_IS_PRE_SAVED_BON", false);
        this.$store.commit("SET_SELECTED_BON_CONSOMMABLES", []);
        this.$store.commit("SET_SELECTED_BON_ID", null)

        this.$store.commit("SET_PAYMENT_ACTION", '');
        this.$store.dispatch('getInfoCliniqueActive')

        // >>>>>>>>>>>  CONSULTATION  <<<<<<<<<<<<<<<<
        this.consult_month_selected = this.currentMonth
        this.$store.dispatch('getCountMonthConsultations', this.currentMonth.english)

        this.getStatConsultation()

        // ------------------------------------------

        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3
            }

            if (this.activeRole.nom == 'ROLE_COMPTABLE' || this.activeRole.nom == 'ROLE_ADMINISTRATEUR') {
                this.$router.push({ path: '/tableau-de-bord' });
            } else if (this.activeRole.nom == 'ROLE_TRESORERIE') {
                this.$router.push({ path: '/tresorerie' });
            }
        }
        this.getCahRegisterStatus()

        // Récupère le solde disponible à une date donnée
        this.getSoldeDisponible()

        let t = this;
        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            if (!$clicked.parents().hasClass("select-box-o")) {
                if (t.curr_state != 0) {
                    t.openSelectOption(t.curr_state, 'slt-month')
                }
            }
        });

        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            this.v = 0;
            if (!$clicked.parents().hasClass("option-container")) {
                $(".option-box").removeClass("animate-fadeInRight");
                $(".option-box").addClass("animate-fadeOutRight");
                $(".option-box").fadeOut();
            }
        });

        this.getListeRDV()
    },

    methods: {
        /**
         * Open Menu Dropdown
         */
        openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        changeTab(tab_to_show) {
            this.config_to_show = tab_to_show
        },

        getListeRDV() {
            this.rdv_loading = true
            store_consultation.getListeRDV().then((rdv_liste) => {
                this.liste_rdv = rdv_liste
                if (rdv_liste.length == 0) {
                    this.rdv_empty = true
                } else {
                    this.rdv_empty = false
                }

                this.rdv_loading = false
            })
        },


        getCompteurConsultations() {
            return new Promise((resolve, reject) => {
                api.getCompteurConsultations().then(
                    (response) => {
                        resolve(response);
                    },
                    (error) => {
                        reject(error);
                    }
                );
            });
        },

        getStatConsultation() {
            this.getCompteurConsultations().then((stat) => {
                this.stat_consultation_en_attente = stat.total_consultation_attente
                this.stat_consultation_du_jour = stat.total_consultation_jour
            })
        },

        /**
         * Check if user can open cash register
         */
        getCahRegisterStatus() {
            const data = {
                compte_id: this.compte_id
            }
            
            this.$store.dispatch('getEtatOuvertureCaisse', data).then(() => {
                this.status_is_loading = false
            })
        },

        // checkCahRegisterStatus() {
        //     if (this.etat_ouverture_caisse.close_status == 0) {
        //         this.cash_register_is_closed = false
        //     } else {
        //         this.cash_register_is_closed = true
        //     }
        // },

        getSoldeDisponible() {
            const data = {
                compte_id: this.compte_id,
                date: this.getDates().today_date,
                user_id: this.user_id
            }
            this.$store.dispatch("getSoldeDisponible", data).then(() => {
                this.solde_courant = parseInt(this.solde_disponible)
            })
        },

        resetStatutCaisse() {
            this.$store.dispatch('getStatutOuvertureCaisse', this.compte_id).then((response) => {
                this.statut_ouverture_caisse = response
            });
        }, 

        ouvrirCaisse() {
            this.open_loading = true;

            // Récupère le solde disponible à une date donnée
            const data = {
                compte_id: this.compte_id,
                date: this.getDates().today_date,
                user_id: this.user_id
            }
            this.$store.dispatch("getSoldeDisponible", data).then(() => {
                this.solde_courant = parseInt(this.solde_courant)

                const opening_data = {
                    compte_id: this.compte_id,
                    user_id: this.user_id,
                    solde_ouverture: this.solde_disponible
                }
          
                this.$store.dispatch('openCaisse', opening_data).then((response) => {
                    if (response.success) {
                        this.getCahRegisterStatus()
                    } else {
                        if (response.code === 409) {
                            this.warningToast("La caisse a été déjà ouverte !")
                        } else if (response.code === 403) {
                            const curr_caisse = (this.compte_id == 1)?'infirmière':'principale'
                            this.warningToast("La caisse "+curr_caisse+" est ouverte !")
                        }
                    }
                    this.open_loading = false;
                }).catch(() => {
                    this.open_loading = false;
                })
            })
        },

        monthsOfYear: function() {

            let month = new Array()
            month = [{
                    "french": "Janvier",
                    "english": "January"
                },
                {
                    "french": "Février",
                    "english": "February",
                },
                {
                    "french": "Mars",
                    "english": "March",
                },
                {
                    "french": "Avril",
                    "english": "April",
                },
                {
                    "french": "Mai",
                    "english": "May",
                },
                {
                    "french": "Juin",
                    "english": "June",
                },
                {
                    "french": "Juillet",
                    "english": "July",
                },
                {
                    "french": "Août",
                    "english": "August",
                },
                {
                    "french": "Septembre",
                    "english": "September",
                },
                {
                    "french": "Octobre",
                    "english": "October",
                },
                {
                    "french": "Novembre",
                    "english": "November",
                },
                {
                    "french": "Décembre",
                    "english": "December",
                },
            ]

            return month
        },
        /**
         * Show select options in dropdown
         * @param {int} j_state 
         * @param {string} selector 
         */
        async openSelectOption(j_state, selector) {
            this.curr_state = openSelectOptions.openSelectOption(j_state, selector)
        },

        /**
         * Select option in dropdown
         * @param {string} selected_value
         * @param {string} selected_id 
         * @param {string} selector 
         * @param {string} model_selector 
         */
        async selectOption(selected_value, selected_id, selector, model_selector) {
            this.curr_state = selectOption.chooseOption(selected_id, selector)

            switch (model_selector) {
                case 'jr':
                    this.jr_selected = selected_value;
                    break;
                case 'mm':
                    this.mm_selected = selected_value;
                    break;
                case 'cm':
                    this.consult_month_selected = selected_value;
                    this.monthConsultationsLoading = true
                    this.$store.dispatch('getCountMonthConsultations', this.consult_month_selected.english).then(
                        () => {
                            this.monthConsultationsLoading = false
                        }
                    )
            }
        },


        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

        getDates() {
            let today_date = new Date();
            let yesterday_date = new Date();
            yesterday_date.setDate(today_date.getDate() - 1);
            today_date = `${today_date.getFullYear()}-${today_date.getMonth() +
            1}-${today_date.getDate()}`;
            yesterday_date = `${yesterday_date.getFullYear()}-${yesterday_date.getMonth() +
            1}-${yesterday_date.getDate()}`;
            return { today_date, yesterday_date };
        },

        dropQuickAction: function() {
            this.$store.dispatch('setQuickActionsDropdown', !this.quick_actions)
        },

        leaveQuickAction: function() {
            this.$store.dispatch('setQuickActionsDropdown', false)
        },

        sum(array_given) {
            let total = 0;
            array_given.forEach(data => {
                total += parseInt(data.quantite * data.prix)
            });
            return total;
        },

        updateStatutCaisse(param) {
            this.statut_ouverture_caisse = param
        },

        showDateFilter(date_filter) {
            this.is_creance_patient = true
            this.filter_date = date_filter
        },

        printBonMedical(data) {
            this.is_bon_consultation = data.is_bon_consultation
            this.info_bon = data.info_bon

            this.bon_is_printable = true
            setTimeout(() => {
                $('.p-bon-medical').modal('show')
                // this.bon_is_printable = false
            }, 200);
        }
    },

}